import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getorders:'/teams/order/getshangwuorder/',


}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function CreateClient (data) {
  return axios({
    url: '/teams/clients/',
    method: 'post',
    data
  })
}

export function getorders (params) {
  return axios({
    url: api.getorders,
    method: 'get',
    params
  })
}
export function getclients (params) {
  return axios({
    url: '/teams/clientsyingshou/',
    method: 'get',
    params
  })
}
export function GetUserList (query) {
  return axios({
    url: '/teams/teams/getshangwusaler/',
    method: 'get',
    params:query
  })
}



// WEBPACK FOOTER //
// ./src/views/salerviews/clientadd/api.js